import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cccdf5dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "control-container" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa mr-2 fa-arrow-left" }, null, -1))
const _hoisted_4 = { class: "mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        id: "previous-button",
        disabled: !_ctx.previousEnabled,
        class: "navigation-btn",
        style: _normalizeStyle(_ctx.containerStyle),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.previousButtonClicked && _ctx.previousButtonClicked(...args)))
      }, [
        _hoisted_3,
        _createElementVNode("span", null, _toDisplayString(_ctx.previousButtonDisplayText()), 1)
      ], 12, _hoisted_2),
      _createElementVNode("button", {
        id: "next-button",
        class: "navigation-btn",
        style: _normalizeStyle({ marginRight: _ctx.rightAlign ? '0' : '15px' }),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextButtonClicked && _ctx.nextButtonClicked(...args)))
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(_ctx.getIconBeforeNext())
        }, null, 2),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.nextButtonDisplayText()), 1),
        _createElementVNode("i", {
          class: _normalizeClass(_ctx.getIconAfterNext())
        }, null, 2)
      ], 4)
    ])
  ]))
}